import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
  NetworkControllerService
} from '@netfoundry-ui/shared/apiv2';
import { saveAs } from 'file-saver';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { HttpErrorResponse } from '@angular/common/http';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import _ from 'lodash';
import { NetworkController } from '@netfoundry-ui/shared/model';


@Component({
    selector: 'lib-network-controller-registration',
    templateUrl: './network-controller-registration.component.html',
    styleUrls: ['./network-controller-registration.component.scss'],
    standalone: false
})
export class NetworkControllerRegistrationComponent implements OnChanges {

    @Input() networkController: NetworkController = new NetworkController();
    @Output() registrationIsLoading = new EventEmitter()
    isLoading = false;
    @Output() controllerHasJwtInfo = new EventEmitter();
    hasJWTInfo = false;
    jwtExpired = false;
    jwt: any;
    jwtExpiration: any;

    constructor(
        public networkControllerService: NetworkControllerService,
        public growlerService: GrowlerService,
    ) {

    }

    ngOnChanges(): void {
        if(this.networkController?.id){
            this.checkForJWT();
        }
    }

    checkForJWT() {
        this.isLoading = true;
        this.registrationIsLoading.emit(this.isLoading);
        this.networkControllerService.getJWT(this.networkController.id).subscribe((result) => {
            this.isLoading = false;
            this.registrationIsLoading.emit(this.isLoading)
            if(result._meta?.zitiManagementIdentity?.enrollment?.ott?.jwt) {
              this.hasJWTInfo = true;
              this.controllerHasJwtInfo.emit(this.hasJWTInfo);
              this.jwt = result._meta?.zitiManagementIdentity?.enrollment?.ott?.jwt;
              if(moment() > result._meta?.zitiManagementIdentity?.enrollment.ott.expiresAt) {
                  this.jwtExpired = true;
              } else {
                  this.jwtExpiration = moment(this.networkController._meta?.zitiManagementIdentity?.enrollment.ott.expiresAt).local().format('M/D/YY h:mm a');
              }
            } else {
                return;
            }
        });
    }

    downloadKey() {
        this.networkControllerService.getJWT(this.networkController.id).subscribe(
            (data) => {
                const name = this.networkController.name;
                const jwt = new Blob([data._meta?.zitiManagementIdentity?.enrollment?.ott?.jwt], { type: 'text/plain;charset=utf-8' });
                saveAs(jwt, name);
                this.growlerService.show(
                    new GrowlerData(
                        'success',
                        'Success',
                        'Enrollment Token Downloaded',
                        'The token has been downloaded.'
                    )
                );
            },
            (err: HttpErrorResponse) => {
                this.growlerService.show(new GrowlerData('error', 'Click to copy request failed.', err.error));
            }
        );
    }


     copyKey() {
        this.networkControllerService.getJWT(this.networkController.id).subscribe(
            (data) => {
                copy(data._meta?.zitiManagementIdentity?.enrollment?.ott?.jwt);
                this.growlerService.show(
                    new GrowlerData(
                        'success',
                        'Success',
                        'Enrollment Token Copied',
                        'The enrollment token has been copied to your clipboard.'
                    )
                );
            },
            (err: HttpErrorResponse) => {
                this.growlerService.show(new GrowlerData('error', 'Click to copy request failed.', err.error));
            }
        );
    }

    copyEnrollmentInstructions() {
        copy(`curl -sSLf https://get.openziti.io/tun/scripts/install-ubuntu.bash | bash
sudo systemctl enable --now ziti-edge-tunnel.service
sudo ziti-edge-tunnel add --jwt ${this.jwt} --identity identityFileName`)
            this.growlerService.show(
                new GrowlerData(
                    'success',
                    'Success',
                    'Instructions Copied',
                    'Enrollment instructions have been copied to your clipboard.'
                )
            )
    }

    get expiration() {
        return _.get(this.networkController, 'registration.expiresAt');
    }


}
